import React, { useEffect } from 'react';
import { Form, Input, Modal, Select, Switch, InputNumber, Row, Col } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { getBrands } from '../../store/actions/brand';

const SeriesForm = ({ visible, onCreate, onCancel, record }) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const brandList = useSelector((state) => state.brand.list);

  // Fetch brands on mount
  useEffect(() => {
    dispatch(getBrands());
  }, [dispatch]);

  // Populate form when editing
  useEffect(() => {
    if (record) {
      form.setFieldsValue({
        name: record.name,
        brandId: record.brandid,
        ordinal: record.ordinal,
        isForAll: record.isForAll ?? false,
      });
    }
  }, [record, form]);

  const handleOk = () => {
    form
      .validateFields()
      .then((values) => {
        onCreate(values);
      })
      .catch(() => { });
  };

  const handleCancel = () => {
    form.resetFields();
    onCancel();
  };

  return (
    <Modal
      open={visible}
      title={record ? 'Edit Series' : 'Add Series'}
      okText={record ? 'Update' : 'Create'}
      cancelText="Cancel"
      onCancel={handleCancel}
      onOk={handleOk}
      destroyOnClose
      zIndex={9999}
    >
      <Form form={form} layout="vertical" name="seriesForm_modal" validateTrigger={["onSubmit", "onChange"]}>
        {/* Brand ID — dropdown with dynamic brand data */}
        <Form.Item
          name="brandId"
          label="Brand"
          rules={[{ required: true, message: 'Please select a brand!' }]}
        >
          <Select placeholder="Select Brand" showSearch optionFilterProp="children" allowClear>
            {brandList.map((brand) => (
              <Select.Option key={brand.id} value={brand.id}>
                {brand.name}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>

        {/* Name */}
        <Form.Item
          name="name"
          label="Series Name"
          rules={[
            { required: true, message: 'Name is required' },
            { type: 'string', message: 'Name should be a string' },
          ]}
        >
          <Input
            placeholder="Enter series name"
            onChange={(e) => {
              const val = e.target.value;
              if (val) {
                form.setFieldValue('name', val.charAt(0).toUpperCase() + val.slice(1));
              }
            }}
          />
        </Form.Item>

        <Row gutter={16}>
          {/* Ordinal */}
          <Col span={12}>
            <Form.Item
              name="ordinal"
              label="Ordinal"
              rules={[{ type: 'number', message: 'Ordinal should be a number' }]}
            >
              <InputNumber placeholder="e.g. 1" style={{ width: '100%' }} min={0} />
            </Form.Item>
          </Col>

          {/* isForAll */}
          {!record && (
            <Col span={12}>
              <Form.Item
                name="isForAll"
                label="Add For All"
                valuePropName="checked"
                initialValue={false}
              >
                <Switch checkedChildren="Yes" unCheckedChildren="No" />
              </Form.Item>
            </Col>
          )}
        </Row>
      </Form>
    </Modal>
  );
};

export default SeriesForm;